module.exports = __webpack_public_path__ + "img/20_86.3fd9a7dd.png";